import { RootState } from "@base/store";
import Hotjar from "@hotjar/browser";
import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

function WithAnalytics<P extends JSX.IntrinsicAttributes>(
  WrappedComponent: any
) {
  const PageAnalytics: React.FC<P> = (props) => {
    const user = useSelector((state: RootState) => state.user.user);
    const ancc = Cookies.get("ANCC");
    const { REACT_APP_HOTJAR_SITE_ID } = process.env;
    const { REACT_APP_HOTJAR_VERSION } = process.env;

    useEffect(() => {
      if (ancc === "true") {
        Hotjar.init(
          parseInt(REACT_APP_HOTJAR_SITE_ID!, 10),
          parseInt(REACT_APP_HOTJAR_VERSION!, 10)
        );
      }
      if (user.uuid) {
        window.analytics.page(window.location.pathname, {
          title: window.location.pathname,
          url: window.location.href,
          path: window.location.pathname,
          properties: {
            user_id: user.uuid, // Add the UUID of the user here
          },
        });
      }
    }, [user, ancc]);

    return <WrappedComponent {...props} />;
  };

  return PageAnalytics;
}

export { WithAnalytics };
